import { Component, ElementRef, OnInit } from '@angular/core';
import * as D3 from 'd3/index'
import { Color } from 'd3/index';

import { Segment } from "../../_interfaces/Segment.model";
import { Risk } from './../../_interfaces/risk.model';
import { RepositoryService } from './../../shared/services/repository.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-strategic-risk-dashboard',
  templateUrl: './strategic-risk-dashboard.component.html',
  styleUrls: ['./strategic-risk-dashboard.component.css']
})
export class StrategicRiskDashboardComponent implements OnInit {
  errorMessage: string;
  host;
  svg;

  segments: Segment[] = new Array();
  public risks: Risk[] = new Array();
  //public risks2: Risk[] = new Array(); //For Debugging

  public fromDate: Date;
  dateForm: FormGroup;
  height;
  //host;
  htmlElement: HTMLElement;
  margin;
  //svg;
  width;
  xAxis;
  xScale;
  yAxis;
  yScale;
  zScale;
  xCenter;
  yCenter;
  maxRadius;

  constructor(private element: ElementRef, private repository: RepositoryService, private formBuilder: FormBuilder) {
    this.host = D3.select(this.element.nativeElement);
   // this.fromDate = new Date();
    // this.fromDate.setDate(this.fromDate.getDate() - 365);
  }


  ngOnInit() {
    this.dateForm = this.formBuilder.group({
      FromDate: Validators.required,
    });
    this.setFromDate();
    this.setup();
    this.getStrategicRisks();
   // this.setup();
   // this.buildSVG();

    // this.setRisk2Data(); //For debugging
  }

  get f() { return this.dateForm.controls; }

  setFromDate() {
    this.fromDate = new Date();
    this.fromDate.setDate(this.fromDate.getDate() - 365);
    const review = formatDate(this.fromDate, 'yyyy-MM-dd', 'en');
    this.f.FromDate.setValue(review);
  }

   // Refresh data values for Radar based on new value of fromDate
  refreshFromDate() {
    this.fromDate = this.f.FromDate.value;
    this.getStrategicRisks();
  }


  public getStrategicRisks() {
    //let apiAddress: string = `Risks/Strategic`; //
    const fromDate = formatDate(this.fromDate, 'yyyy-MM-dd', 'en');
    let apiAddress: string = `Risks/Strategic/Since/` + fromDate;; // ToDo - create Api endpoint `Risks/Strategic/Since/{FromDate}` then call it here to include change data

    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.risks = res as Risk[];
        //this.risks = this.risks2; //For debugging
        this.setDefaultProximityValues();
        //this.setup();
        this.buildSVG();
      });
  }

  // For debugging
  //setRisk2Data() {
  //  var risk10 = new Risk();
  //  risk10.proximity = 4;
  //  risk10.impact = 40;
  //  risk10.id = 10;
  //  risk10.strategicRiskType = 6;
  //  risk10.probability = 20;
  //  risk10.title = "Property Investment";
  //  risk10.randomOffset = 0.2;

  //  var risk126 = new Risk();
  //  risk126.proximity = 5;
  //  risk126.impact = 10;
  //  risk126.id = 126;
  //  risk126.strategicRiskType = 6;
  //  risk126.probability = 20;
  //  risk126.title = "Alternative Investment - Mojo Mortgages";
  //  risk126.randomOffset = 0.5;

  //  this.risks2.push(risk10);
  //  this.risks2.push(risk126);
  //}

  randomOffset(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  setDefaultProximityValues(){
    this.risks.forEach(f => { if (f.proximity === null) { f.proximity = 1 } });

    this.risks.forEach(f => {
      f.randomOffset = this.randomOffset(0.10, 0.90);
    });

    let outlookTest = 0;
    this.risks.forEach(f => {
      if (f.impactOutlook === null) {
        f.impactOutlook = 0;
      }
      //f.impactOutlook = outlookTest;

      //if (outlookTest === 0) {
      //  outlookTest = 1;
      //}
      //else {
      //  if (outlookTest === 1) {
      //    outlookTest = -1
      //  }
      //  else {
      //    outlookTest = 0;
      //  }
      //}
    });
}

  setup() {
    this.margin = {
      top: 15,
      right: 100,
      bottom: 40,
      left: 0
    };

    this.width = 1280 - this.margin.left - this.margin.right;
    //this.width = document.querySelector('#strategic-risk-dartboard').clientWidth - this.margin.left - this.margin.right;
    this.height = this.width * 0.6 - this.margin.bottom - this.margin.top;
    this.xScale = D3.scaleLinear().range([0, this.width]);
    this.yScale = D3.scaleLinear().range([this.height, 0]);
    this.zScale = D3.scaleLinear().range([2, 15]);
    this.xCenter = this.width/2 ;
    this.yCenter = this.height / 2;
    this.maxRadius = 4 * this.height / 9;

    const segment1: Segment = { name: 'Project', size: 1 };
    const segment2: Segment = { name: 'New Business', size: 1 };
    const segment3: Segment = { name: 'Strategic and Structural Issues', size: 1 };
    const segment4: Segment = { name: 'Political Legal & Regulatory', size: 1 };
    const segment5: Segment = { name: 'Macro-Economic Environment', size: 1 };
    const segment6: Segment = { name: 'Infrastructure', size: 1 };


    this.segments.push(segment1);
    this.segments.push(segment2);
    this.segments.push(segment3);
    this.segments.push(segment4);
    this.segments.push(segment5);
    this.segments.push(segment6);
  }

  buildSVG(): void {

    //  Draw 5 concentric circles
    var or1 = this.maxRadius / 5;
    var or2 = 2 * or1;

    var arcGen1 = D3.arc()
      .innerRadius(0)
      .outerRadius(or1)
      .startAngle(0) 
      .endAngle(2 * Math.PI);

    var arcGen2 = D3.arc()
      .innerRadius(or1)
      .outerRadius(or2)
      .startAngle(0)
      .endAngle(2 * Math.PI);

    


    let angleGen = D3.pie<Segment>()
      .startAngle(0)
      .endAngle((2 * Math.PI) )
      .padAngle(.05)
      .value((d) => d.size);
   // .sortValues(null);

    var dataset = angleGen(this.segments); // angleGen(input);//  angleGen([1,1,1,1,1,1]); //

    var arcGen3 = D3.arc()
      .innerRadius(5)
      .outerRadius(this.maxRadius/5); // this.maxRadius

    var arcGen4 = D3.arc()
      .innerRadius(this.maxRadius / 5)
      .outerRadius(2 * this.maxRadius / 5);

    var arcGen5 = D3.arc()
      .innerRadius(2 * this.maxRadius / 5)
      .outerRadius(3 * this.maxRadius / 5);

    var arcGen6 = D3.arc()
      .innerRadius(3 * this.maxRadius / 5)
      .outerRadius(4 * this.maxRadius / 5);

    var arcGen7 = D3.arc()
      .innerRadius(4 * this.maxRadius / 5)
      .outerRadius(5 * this.maxRadius / 5);

    // ToDo - RDP- 151 Make triangles on Strategic Risk Radar diagram Isosceles and have a tilt angle (towards, equal or away) related to change in probability.
    // ToDo - RDP-158 - Add impact outlook field and use existing impact field to set the size of the triangle - 
    // ToDo - RDP-159 Make triangles on Strategic Risk Radar diagram Pointable and have a tilt angle (towards, equal or away) related to the new impact outlook field
    // ToDo - 1 Make triangles on Strategic Risk Radar diagram Isosceles - by creating a custom D3 Symbol
    // ToDo - 2 Update the triangle geneartor to use the new Isosceles Triangle symbol
    // ToDo - 3 Rotate the new triangles to match the angle of the segment
    // ToDo - 4 Give each triangle a tilt angle(towards, equal or away) related to the change in probability.

    //let eqTriangle = function (size) {
    //  size = size || 64;
    //  return function (size) {
    //    size = Math.sqrt(size);
    //    let rx = size / 5,
    //      ry = rx * 5;
    //    return "M0," + -ry
    //      + "L" + rx + "," + ry
    //      + " " + -rx + "," + ry
    //      + "Z";
    //  }
    //}

    var customShapeTri = {
      draw: function (context, size) {
        let s = Math.sqrt(size);
        let t = s / 2;
        context.moveTo(s, t)
        context.lineTo(-s, 0);
        context.lineTo(s, -t);
        context.closePath();
      }
    }


    // var triangle = D3.symbol().type(D3.symbolTriangle); // Old equilateral triangle
    var triangle = D3.symbol().type(customShapeTri); // new isoceles triangle
      
    
    const points = [
      [0, 100],
      [500, 100],
    ];

    // ToDo - RDP-150 Add 'Indication of Movement' line to Strategic Risk Radar diagram.
    // We need to plot the movement line as a radial line but the D3 line radial method plots a line chart connecting radial points
    // We need a radial line connecting to values of the same data point
    // Another approach would be to create a custom "line symbol' and overlay it on the triangle with the correct rotation

    // let movementLine = D3.lineRadial();



    //var color = D3.scaleLinear<number, Color>()
    //  .domain([0, 1])
    //  .range(["orange", "white"]);

    var baseColor = D3.interpolateOranges(0.8);//D3.color("red"); //
    var Color1 = D3.interpolateOranges(0.6);//D3.color("orange"); //baseColor.brighter(0.4); //
    var Color2 = D3.interpolateOranges(0.4);//D3.color("orange"); // Color1.brighter(0.4); // color(0.4);//
    var Color3 = D3.interpolateOranges(0.2);//D3.color("orange"); // Color2.brighter(0.5); //color(0.6);//
    var Color4 = D3.interpolateOranges(0);//D3.color("white");//color(0.8);//

    const labelLocation = D3.arc()
      .innerRadius(this.maxRadius + 20)
      .outerRadius(this.maxRadius + 120);

    // Triangle colours
    var triangleColor = D3.scaleThreshold<number,string>()
      .domain([20, 40, 60, 80,100]) 
      .range(["green","lightgreen", "yellow","pink", "red", "pink"]); // .range(["green", "yellow", "red", "pink"]); //  .domain([30, 70, 100]) 


    //const triangleLocation = D3.arc()
    //  .innerRadius(this.maxRadius + 20)
    //  .outerRadius(this.maxRadius + 120);



    //this.host.html('');
    // this.svg = this.host.append('svg')
    //.attr('width', this.width + this.margin.left + this.margin.right)
    //  .attr('height', this.height + this.margin.top + this.margin.bottom);

    // created a 6 slice exploded donut with 1 layer
    // created multiple donut rings for the proximities


    this.svg = D3.select("#strategic-risk-dartboard") 
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom);

    this.svg.selectAll("path").remove();

    // Centre of Radar - Proximity 1
    var g = this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("path")
      .data(dataset)
      .enter()
      .append("path")
      .attr("d", arcGen3)
      .attr("fill", baseColor)
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      .append("path");


    // Proximity 2
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(dataset)
      .enter()
      .append("path")
      .attr("d", arcGen4)
      .attr("fill", Color1)
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      .append("path");

    // Proximity 3
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(dataset)
      .enter()
      .append("path")
      .attr("d", arcGen5)
      .attr("fill", Color2)
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      .append("path");

    // Proximity 4
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(dataset)
      .enter()
      .append("path")
      .attr("d", arcGen6)
      .attr("fill", Color3)
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      .append("path");

    // Proximity 5
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(dataset)
      .enter()
      .append("path")
      .attr("d", arcGen7)
      .attr("fill", Color4)
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      .append("path");

    // Proximity 6
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(dataset)
      .enter()
      .append("text")
      .text(d => d.data.name)
      .attr("transform", d => "translate(" + labelLocation.centroid(d) + ")")
      .style("text-anchor", "middle")
      .style("font-size", 10);

    // Write triangles
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(this.risks)
      .enter()
      .append('path')
      .transition()
      .duration(1500)
      .attr("d", triangle.size(f => f.impact * 20))
      //.attr("d", eqTriangle)
      //.attr("transform", d => "translate(" + arcGen6.centroid(d) + ")")
      //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + 0.5 - (d.id / 50)) * Math.PI / 3, (d.proximity - 0.5 - (d.id / 50)) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
      //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
      .attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ") rotate(" + ((60 * (d.strategicRiskType + (-0.5 + d.randomOffset) / 3)) + 210 + d.impactOutlook * 30)  + ")") 
      .attr("fill", e => triangleColor(e.probability))
      .attr("stroke", "gray") 
      .attr("stroke-width", 1);

    // Write eq triangles
    //this.svg
    //  .append('g')
    //  .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
    //  .selectAll("newPath")
    //  .data(this.risks)
    //  .enter()
    //  .append('path')
    //  //.attr("d", triangle.size(f => f.impact * 20))
    //  .attr("d", eqTriangle.size(f => f.impact * 20))
    //  .attr("fill", "blue")
    //  //.attr("transform", d => "translate(" + arcGen6.centroid(d) + ")")
    //  //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + 0.5 - (d.id / 50)) * Math.PI / 3, (d.proximity - 0.5 - (d.id / 50)) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
    //  .attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
    //  //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ") rotate(-45)") 
    //  //.attr("fill", e => triangleColor(e.probability))
    //  .attr("stroke", "blue")
    //  .attr("stroke-width", 10);

    // Write Indication of Movement Line
    //this.svg
    //  .append('g')
    //  .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
    //  .selectAll("newPath")
    //  .data(this.risks)
    //  .enter()
    //  .append('path')
    //  .attr("d", movementLine) //
    //  //.attr("d", eqTriangle(f => f.impact * 20))
    //  .attr("fill", "blue")
    //  .attr("angle", d => (d.strategicRiskType + d.randomOffset) * Math.PI / 3)
    //  .attr("radius", d => (d.proximity - d.randomOffset) * this.maxRadius / 5)
    //  // f => f.proximity - f.previousProximity
    //  //.attr("transform", d => "translate(" + arcGen6.centroid(d) + ")")
    //  //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + 0.5 - (d.id / 50)) * Math.PI / 3, (d.proximity - 0.5 - (d.id / 50)) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
    //  //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ")") // (0.5 + d.Proximity)
    //  //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ") rotate(-45)") 
    //  // .attr("fill", "blue")
    //  .attr("stroke", "blue")
    //  .attr("stroke-width", 10);

    // Write risk number
    this.svg
      .append('g')
      .attr("transform", "translate(" + this.xCenter + ", " + this.yCenter + ")")
      .selectAll("newPath")
      .data(this.risks)
      .enter()
      .append("text")
      .text(d => d.id)
      //.attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + 0.5 - (d.id / 50)) * Math.PI / 3, (d.proximity - 0.5 -(d.id / 50)) * this.maxRadius / 5) + ")")// "translate(" + d.strategicRiskType * 50 + ", " + d.netCost / 1000 + ")")
      .attr("transform", d => "translate(" + D3.pointRadial((d.strategicRiskType + d.randomOffset) * Math.PI / 3, (d.proximity - d.randomOffset) * this.maxRadius / 5) + ")")// "translate(" + d.strategicRiskType * 50 + ", " + d.netCost / 1000 + ")")
      .style("text-anchor", "middle")
      .style("font-size", 10);


    var legendData = [["Low Probability", "green", "320"], ["Medium-Low Probability", "lightgreen", "320"], ["Medium Probability", "yellow", "320"], ["Medium-High Probability", "pink", "320"], ["High Probability", "red", "320"], ["Low Impact", "white", "64"], ["Medium-Low Impact", "white", "125"], ["Medium Impact", "white", "250"], ["Medium-High Impact", "white", "375"], ["High Impact", "white", "600"]];

    var legend = this.svg.append('g')
      .attr("class", "legend")
      .attr("height", 0)
      .attr("width", 0)
      .attr('transform', 'translate(20,60)');

    var legendRect = legend
      .selectAll('g')
      .data(legendData);

    var legendRectE = legendRect.enter()
      .append("g")
      .attr("transform", function (d, i) {
        return 'translate(0, ' + (i * 40) + ')';
      });

    legendRectE
      .append('path')
      .attr("d", triangle.size(d => d[2]))
      .style("fill", d => d[1])
      .attr("stroke", "gray")
      .attr("stroke-width", 1);

    legendRectE
      .append("text")
      .attr("x", 50)
      .attr("y", 0)
      .text(function (d) {
        return d[0];
      });

    //this.svg
    //  .data(data)
    //  .enter()
    //  .append("path")
    //  .attr("d", arcGen3)
    //  .attr("fill", "pink")
    //  .attr("stroke", "gray")
    //  .attr("stroke-width", 1);

      //.attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');
      //.style('background-color', 'blue');
  }
    getSymbol(getSymbol: any) {
        throw new Error('Method not implemented.');
    }

}
